module.exports = __webpack_public_path__ + "static/grayling.c1acc107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/grayling.png
// module id = 512
// module chunks = 263791100135453